export default __webpack_public_path__ + "static/media/prev-NDNU-5.656a9695.png";